import React, { useEffect, useRef } from 'react'
import { useLocation } from "react-router-dom"
import ContactWellezy from '../ContactWellezy/ContactWellezy'
import banner from "./assets/img/RECURSOS09.png"
import bannerSantander from "./assets/img/santander.png"
import Whatsapp from "./assets/img/RECURSOS08.png"
import bag from "./assets/img/RECURSOS06.png"
import food from "./assets/img/RECURSOS05.png"
import taxi from "./assets/img/RECURSOS07.png"
import health from "./assets/img/RECURSOS03.png"
import hospital from "./assets/img/RECURSOS02.png"

import letters from "./assets/img/RECURSOS04.png"
import ticket from "./assets/img/Mesadetrabajo.png"
import Carousel from "react-elastic-carousel";
import Item from "./Item";

import styled from 'styled-components'
import { motion, useDragControls } from 'framer-motion'
import { Grid } from '@mui/material'

import "./assets/styles.css"

import lettersSantander from "./assets/img/lettersSantander.png"



const MotionConstraints = styled(motion.div)`
    overflow-x: hidden;
  `;

const MotionBox = styled(motion.div)`
    width: 400vw;
  `

const PackahesTourism = () => {
    const { pathname } = useLocation();
    const constraintsRef = useRef(null)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const location = useLocation()
    const position = location.pathname.split('/')[2]
    console.log(position)

    const atraccionesCafetero = [
        {
            img: "https://www.triviantes.com/wp-content/uploads/2021/02/parque-del-cafe-ubicacion-1-800x600.jpg",
            text: "Parque del Cafe"
        },
        {
            img: "https://www.naturalezaydescanso.com/wp-content/uploads/2020/04/13147511_1067944023265041_2579654247864957764_o-scaled.jpg",
            text: "Panaca"
        },
        {
            img: "https://www.triviantes.com/wp-content/uploads/2022/09/que-hacer-en-Termales-de-Santa-Rosa-de-Cabal-2.jpg",
            text: "Termales de Santa Rosa"
        },
        {
            img: "https://thumbs.dreamstime.com/b/valle-de-cocora-eje-cafetero-salento-colombia-valle-de-cocora-eje-cafetero-salento-colombia-237025062.jpg",
            text: "Valle del Cocora"
        },
    ]

    const atraccionesSantander = [
        {
            img: "https://www.vanguardia.com/binrepository/716x687/0c105/716d477/none/12204/SUTE/bjp0-c8w_4482747_20200605074018.jpg",
            text: "Socorro Santander"
        },
        {
            img: "https://santander.gov.co/info/santander_se/media/pubInt/thumbs/thpubInt_700X400_8057.webp",
            text: "Panachi"
        },
        {
            img: "http://guiaturisticadesantander.com/wp-content/uploads/2019/09/san-gil-guia-turismo-santander-18.jpg",
            text: "San Gil"
        },
        {
            img: "https://cdn.colombia.com/sdi/2015/10/20/giron-709555.jpg",
            text: "Municipio de Giron"
        },
    ]

    const breakPoints = [
        { width: 100, itemsToShow: 1, itemsToScroll: 1 },
        { width: 600, itemsToShow: 2, itemsToScroll: 2 },
        { width: 900, itemsToShow: 3 },
        { width: 1200, itemsToShow: 4, itemsToScroll: 4 }
    ];

    return (
        <div>
            {
                position === "EjeCafetero" &&
                <>
                    <header className='header-packages' style={{ backgroundImage: `url(${banner})` }}>
                        <img src={letters} alt="" className='img-letters' />
                    </header>
                    <main className='contain-info'>
                        <div className='flex-dir-layout'>
                            <div className='layout-titles'>
                                <span></span>
                                <h3>Tarifas desde</h3>
                                <span></span>
                            </div>
                            <div>
                                <p className='price-packages'>$599.000</p>
                            </div>
                            <div className='layout-contenido-info'>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Incluye</h3>
                                        <span></span>
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Traslados desde Medellín a todos los sitios de interes</p>
                                        <img src={taxi} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Tour y guía acompañante durante todo el recorrido</p>
                                        <img src={bag} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Desayunos, y cenas por noche de alojamiento</p>
                                        <img src={food} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Tarjeta de asistencia médica</p>
                                        <img src={health} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>3 noches 4 días</p>
                                        <img src={hospital} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Ingreso a todos los sitios de interes</p>
                                        <img src={ticket} alt="" />
                                    </div>

                                </div>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Fechas</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas'>
                                        <ul>
                                            <li>
                                                Del <span>21</span>  al <span>24</span>  de Abril
                                            </li>
                                            <li>
                                                Del <span>12</span>  al <span>15</span>  de Mayo
                                            </li>
                                            <li>
                                                Del <span>6</span>  al <span>9</span>  de Junio
                                            </li>
                                            <li>
                                                Del <span>20</span>  al <span>23</span>  de Junio
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='layout-sub-titles mt-4'>
                                        <span></span>
                                        <h3>Ten en Cuenta</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas-two'>
                                        <ul>
                                            <li>Salida puntual.</li>
                                            <li>Tarifas por persona en pesos colombianos.</li>
                                            <li>Tarifas sujetas a cambios.</li>
                                            <li>Solicita las recomendaciones para este plan al momento de realizar tu reserva.</li>
                                            <li>Tarifas incluyen IVA.</li>
                                            <li>Estamos comprometidos con la ley 679-200</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='contain-conoce'>
                                <div className='layout-conoce-titles'>
                                    <span></span>
                                    <h4>Conoce</h4>
                                    <span></span>
                                </div>
                                <MotionConstraints className='slider_container' ref={constraintsRef}>
                                    <MotionBox className='slider_' drag='x' dragConstraints={constraintsRef}  >
                                        {
                                            atraccionesCafetero.map((topic) => {
                                                return (
                                                    <motion.div className='div_homeTurism' key={topic.text}>
                                                        <Grid item xs={6} sm={6} md={3} lg={2} className='grid_cardHomeTurism'>
                                                            <div className='contain-carousel-packages'>
                                                                <img src={topic.img} alt={topic.text} />
                                                                <h4 style={{ color: "black" }}>{topic.text}</h4>
                                                            </div>
                                                        </Grid>
                                                    </motion.div>
                                                )
                                            })
                                        }

                                    </MotionBox>
                                </MotionConstraints>
                            </div>
                            <div className='contain-button-whatsapp'>
                                <a href='https://wa.link/7mlvuu' target={"_blank"}>
                                    <img src={Whatsapp} alt="" />
                                    <p>
                                        Habla con un asesor viaja al Eje Cafetero
                                    </p>
                                </a>
                            </div>
                        </div>
                    </main>
                </>
            }
            {
                position === "SanAndres" &&
                <>
                    <header className='header-packages' style={{ backgroundImage: `url(${banner})` }}>
                        <img src={letters} alt="" className='img-letters' />
                    </header>
                    <main className='contain-info'>
                        <div className='flex-dir-layout'>
                            <div className='layout-titles'>
                                <span></span>
                                <h3>Tarifas desde</h3>
                                <span></span>
                            </div>
                            <div>
                                <p className='price-packages'>$599.000</p>
                            </div>
                            <div className='layout-contenido-info'>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Incluye</h3>
                                        <span></span>
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Traslados desde Medellín a todos los sitios de interes</p>
                                        <img src={taxi} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Tour y guía acompañante durante todo el recorrido</p>
                                        <img src={bag} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Desayunos, y cenas por noche de alojamiento</p>
                                        <img src={food} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Tarjeta de asistencia médica</p>
                                        <img src={health} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>3 noches 4 días</p>
                                        <img src={hospital} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Ingreso a todos los sitios de interes</p>
                                        <img src={ticket} alt="" />
                                    </div>

                                </div>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Fechas</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas'>
                                        <ul>
                                            <li>
                                                Del <span>21</span>  al <span>24</span>  de Abril
                                            </li>
                                            <li>
                                                Del <span>12</span>  al <span>15</span>  de Mayo
                                            </li>
                                            <li>
                                                Del <span>6</span>  al <span>9</span>  de Junio
                                            </li>
                                            <li>
                                                Del <span>20</span>  al <span>23</span>  de Junio
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='layout-sub-titles mt-4'>
                                        <span></span>
                                        <h3>Ten en Cuenta</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas-two'>
                                        <ul>
                                            <li>Salida puntual.</li>
                                            <li>Tarifas por persona en pesos colombianos.</li>
                                            <li>Tarifas sujetas a cambios.</li>
                                            <li>Solicita las recomendaciones para este plan al momento de realizar tu reserva.</li>
                                            <li>Tarifas incluyen IVA.</li>
                                            <li>Estamos comprometidos con la ley 679-200</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='contain-conoce'>
                                <div className='layout-conoce-titles'>
                                    <span></span>
                                    <h4>Conoce</h4>
                                    <span></span>
                                </div>
                                <MotionConstraints className='slider_container' ref={constraintsRef}>
                                    <MotionBox className='slider_' drag='x' dragConstraints={constraintsRef}  >
                                        {
                                            atraccionesCafetero.map((topic) => {
                                                return (
                                                    <motion.div className='div_homeTurism' key={topic.text}>
                                                        <Grid item xs={6} sm={6} md={3} lg={2} className='grid_cardHomeTurism'>
                                                            <div className='contain-carousel-packages'>
                                                                <img src={topic.img} alt={topic.text} />
                                                                <h4 style={{ color: "black" }}>{topic.text}</h4>
                                                            </div>
                                                        </Grid>
                                                    </motion.div>
                                                )
                                            })
                                        }

                                    </MotionBox>
                                </MotionConstraints>
                            </div>
                            <div className='contain-button-whatsapp'>
                                <a href='https://wa.link/7mlvuu' target={"_blank"}>
                                    <img src={Whatsapp} alt="" />
                                    <p>
                                        Habla con un asesor viaja al Eje Cafetero
                                    </p>
                                </a>
                            </div>
                        </div>
                    </main>
                </>
            }
            {
                position === "SantaMarta" &&
                <>
                    <header className='header-packages' style={{ backgroundImage: `url(${banner})` }}>
                        <img src={letters} alt="" className='img-letters' />
                    </header>
                    <main className='contain-info'>
                        <div className='flex-dir-layout'>
                            <div className='layout-titles'>
                                <span></span>
                                <h3>Tarifas desde</h3>
                                <span></span>
                            </div>
                            <div>
                                <p className='price-packages'>$599.000</p>
                            </div>
                            <div className='layout-contenido-info'>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Incluye</h3>
                                        <span></span>
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Traslados desde Medellín a todos los sitios de interes</p>
                                        <img src={taxi} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Tour y guía acompañante durante todo el recorrido</p>
                                        <img src={bag} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Desayunos, y cenas por noche de alojamiento</p>
                                        <img src={food} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Tarjeta de asistencia médica</p>
                                        <img src={health} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>3 noches 4 días</p>
                                        <img src={hospital} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Ingreso a todos los sitios de interes</p>
                                        <img src={ticket} alt="" />
                                    </div>

                                </div>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Fechas</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas'>
                                        <ul>
                                            <li>
                                                Del <span>21</span>  al <span>24</span>  de Abril
                                            </li>
                                            <li>
                                                Del <span>12</span>  al <span>15</span>  de Mayo
                                            </li>
                                            <li>
                                                Del <span>6</span>  al <span>9</span>  de Junio
                                            </li>
                                            <li>
                                                Del <span>20</span>  al <span>23</span>  de Junio
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='layout-sub-titles mt-4'>
                                        <span></span>
                                        <h3>Ten en Cuenta</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas-two'>
                                        <ul>
                                            <li>Salida puntual.</li>
                                            <li>Tarifas por persona en pesos colombianos.</li>
                                            <li>Tarifas sujetas a cambios.</li>
                                            <li>Solicita las recomendaciones para este plan al momento de realizar tu reserva.</li>
                                            <li>Tarifas incluyen IVA.</li>
                                            <li>Estamos comprometidos con la ley 679-200</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='contain-conoce'>
                                <div className='layout-conoce-titles'>
                                    <span></span>
                                    <h4>Conoce</h4>
                                    <span></span>
                                </div>
                                <MotionConstraints className='slider_container' ref={constraintsRef}>
                                    <MotionBox className='slider_' drag='x' dragConstraints={constraintsRef}  >
                                        {
                                            atraccionesCafetero.map((topic) => {
                                                return (
                                                    <motion.div className='div_homeTurism' key={topic.text}>
                                                        <Grid item xs={6} sm={6} md={3} lg={2} className='grid_cardHomeTurism'>
                                                            <div className='contain-carousel-packages'>
                                                                <img src={topic.img} alt={topic.text} />
                                                                <h4 style={{ color: "black" }}>{topic.text}</h4>
                                                            </div>
                                                        </Grid>
                                                    </motion.div>
                                                )
                                            })
                                        }

                                    </MotionBox>
                                </MotionConstraints>
                            </div>
                            <div className='contain-button-whatsapp'>
                                <a href='https://wa.link/7mlvuu' target={"_blank"}>
                                    <img src={Whatsapp} alt="" />
                                    <p>
                                        Habla con un asesor viaja al Eje Cafetero
                                    </p>
                                </a>
                            </div>
                        </div>
                    </main>
                </>
            }
            {
                position === "Cartagena" &&
                <>
                    <header className='header-packages' style={{ backgroundImage: `url(${banner})` }}>
                        <img src={letters} alt="" className='img-letters' />
                    </header>
                    <main className='contain-info'>
                        <div className='flex-dir-layout'>
                            <div className='layout-titles'>
                                <span></span>
                                <h3>Tarifas desde</h3>
                                <span></span>
                            </div>
                            <div>
                                <p className='price-packages'>$599.000</p>
                            </div>
                            <div className='layout-contenido-info'>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Incluye</h3>
                                        <span></span>
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Traslados desde Medellín a todos los sitios de interes</p>
                                        <img src={taxi} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Tour y guía acompañante durante todo el recorrido</p>
                                        <img src={bag} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Desayunos, y cenas por noche de alojamiento</p>
                                        <img src={food} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Tarjeta de asistencia médica</p>
                                        <img src={health} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>3 noches 4 días</p>
                                        <img src={hospital} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Ingreso a todos los sitios de interes</p>
                                        <img src={ticket} alt="" />
                                    </div>

                                </div>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Fechas</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas'>
                                        <ul>
                                            <li>
                                                Del <span>21</span>  al <span>24</span>  de Abril
                                            </li>
                                            <li>
                                                Del <span>12</span>  al <span>15</span>  de Mayo
                                            </li>
                                            <li>
                                                Del <span>6</span>  al <span>9</span>  de Junio
                                            </li>
                                            <li>
                                                Del <span>20</span>  al <span>23</span>  de Junio
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='layout-sub-titles mt-4'>
                                        <span></span>
                                        <h3>Ten en Cuenta</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas-two'>
                                        <ul>
                                            <li>Salida puntual.</li>
                                            <li>Tarifas por persona en pesos colombianos.</li>
                                            <li>Tarifas sujetas a cambios.</li>
                                            <li>Solicita las recomendaciones para este plan al momento de realizar tu reserva.</li>
                                            <li>Tarifas incluyen IVA.</li>
                                            <li>Estamos comprometidos con la ley 679-200</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='contain-conoce'>
                                <div className='layout-conoce-titles'>
                                    <span></span>
                                    <h4>Conoce</h4>
                                    <span></span>
                                </div>
                                <MotionConstraints className='slider_container' ref={constraintsRef}>
                                    <MotionBox className='slider_' drag='x' dragConstraints={constraintsRef}  >
                                        {
                                            atraccionesCafetero.map((topic) => {
                                                return (
                                                    <motion.div className='div_homeTurism' key={topic.text}>
                                                        <Grid item xs={6} sm={6} md={3} lg={2} className='grid_cardHomeTurism'>
                                                            <div className='contain-carousel-packages'>
                                                                <img src={topic.img} alt={topic.text} />
                                                                <h4 style={{ color: "black" }}>{topic.text}</h4>
                                                            </div>
                                                        </Grid>
                                                    </motion.div>
                                                )
                                            })
                                        }

                                    </MotionBox>
                                </MotionConstraints>
                            </div>
                            <div className='contain-button-whatsapp'>
                                <a href='https://wa.link/7mlvuu' target={"_blank"}>
                                    <img src={Whatsapp} alt="" />
                                    <p>
                                        Habla con un asesor viaja al Eje Cafetero
                                    </p>
                                </a>
                            </div>
                        </div>
                    </main>
                </>
            }
            {
                position === "Guatape" &&
                <>
                    <header className='header-packages' style={{ backgroundImage: `url(${banner})` }}>
                        <img src={letters} alt="" className='img-letters' />
                    </header>
                    <main className='contain-info'>
                        <div className='flex-dir-layout'>
                            <div className='layout-titles'>
                                <span></span>
                                <h3>Tarifas desde</h3>
                                <span></span>
                            </div>
                            <div>
                                <p className='price-packages'>$599.000</p>
                            </div>
                            <div className='layout-contenido-info'>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Incluye</h3>
                                        <span></span>
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Traslados desde Medellín a todos los sitios de interes</p>
                                        <img src={taxi} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Tour y guía acompañante durante todo el recorrido</p>
                                        <img src={bag} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Desayunos, y cenas por noche de alojamiento</p>
                                        <img src={food} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Tarjeta de asistencia médica</p>
                                        <img src={health} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>3 noches 4 días</p>
                                        <img src={hospital} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Ingreso a todos los sitios de interes</p>
                                        <img src={ticket} alt="" />
                                    </div>

                                </div>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Fechas</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas'>
                                        <ul>
                                            <li>
                                                Del <span>21</span>  al <span>24</span>  de Abril
                                            </li>
                                            <li>
                                                Del <span>12</span>  al <span>15</span>  de Mayo
                                            </li>
                                            <li>
                                                Del <span>6</span>  al <span>9</span>  de Junio
                                            </li>
                                            <li>
                                                Del <span>20</span>  al <span>23</span>  de Junio
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='layout-sub-titles mt-4'>
                                        <span></span>
                                        <h3>Ten en Cuenta</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas-two'>
                                        <ul>
                                            <li>Salida puntual.</li>
                                            <li>Tarifas por persona en pesos colombianos.</li>
                                            <li>Tarifas sujetas a cambios.</li>
                                            <li>Solicita las recomendaciones para este plan al momento de realizar tu reserva.</li>
                                            <li>Tarifas incluyen IVA.</li>
                                            <li>Estamos comprometidos con la ley 679-200</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='contain-conoce'>
                                <div className='layout-conoce-titles'>
                                    <span></span>
                                    <h4>Conoce</h4>
                                    <span></span>
                                </div>
                                <MotionConstraints className='slider_container' ref={constraintsRef}>
                                    <MotionBox className='slider_' drag='x' dragConstraints={constraintsRef}  >
                                        {
                                            atraccionesCafetero.map((topic) => {
                                                return (
                                                    <motion.div className='div_homeTurism' key={topic.text}>
                                                        <Grid item xs={6} sm={6} md={3} lg={2} className='grid_cardHomeTurism'>
                                                            <div className='contain-carousel-packages'>
                                                                <img src={topic.img} alt={topic.text} />
                                                                <h4 style={{ color: "black" }}>{topic.text}</h4>
                                                            </div>
                                                        </Grid>
                                                    </motion.div>
                                                )
                                            })
                                        }

                                    </MotionBox>
                                </MotionConstraints>
                            </div>
                            <div className='contain-button-whatsapp'>
                                <a href='https://wa.link/7mlvuu' target={"_blank"}>
                                    <img src={Whatsapp} alt="" />
                                    <p>
                                        Habla con un asesor viaja al Eje Cafetero
                                    </p>
                                </a>
                            </div>
                        </div>
                    </main>
                </>
            }
            {
                position === "Santander" &&
                <>
                    <header className='header-packages' style={{ backgroundImage: `url(${bannerSantander})` }}>
                        <img src={lettersSantander} alt="" className='img-letters' />
                    </header>
                    <main className='contain-info'>
                        <div className='flex-dir-layout'>
                            <div className='layout-titles'>
                                <span></span>
                                <h3>Tarifas desde</h3>
                                <span></span>
                            </div>
                            <div>
                                <p className='price-packages'>$599.000</p>
                            </div>
                            <div className='layout-contenido-info'>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Incluye</h3>
                                        <span></span>
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Traslados desde Medellín a todos los sitios de interes</p>
                                        <img src={taxi} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Tour y guía acompañante durante todo el recorrido</p>
                                        <img src={bag} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Desayunos, y cenas por noche de alojamiento</p>
                                        <img src={food} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p> Tarjeta de asistencia médica</p>
                                        <img src={health} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>3 noches 4 días</p>
                                        <img src={hospital} alt="" />
                                    </div>
                                    <div className='items-incluye'>
                                        <p>Ingreso a todos los sitios de interes</p>
                                        <img src={ticket} alt="" />
                                    </div>

                                </div>
                                <div className='sub-contain-info'>
                                    <div className='layout-sub-titles'>
                                        <span></span>
                                        <h3>Fechas</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas'>
                                        <ul>
                                            <li>
                                                Del <span>14</span>  al <span>17</span>  de abril
                                            </li>
                                            <li>
                                                Del <span>31</span>  de marzo al <span>17</span>  de abril
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='layout-sub-titles mt-4'>
                                        <span></span>
                                        <h3>Ten en Cuenta</h3>
                                        <span></span>
                                    </div>
                                    <div className='list-fechas-two'>
                                        <ul>
                                            <li>Salida puntual.</li>
                                            <li>Tarifas por persona en pesos colombianos.</li>
                                            <li>Tarifas sujetas a cambios.</li>
                                            <li>Solicita las recomendaciones para este plan al momento de realizar tu reserva.</li>
                                            <li>Tarifas incluyen IVA.</li>
                                            <li>Estamos comprometidos con la ley 679-200</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='contain-conoce'>
                                <div className='layout-conoce-titles'>
                                    <span></span>
                                    <h4>Conoce</h4>
                                    <span></span>
                                </div>
                                <MotionConstraints className='slider_container' ref={constraintsRef}>
                                    <MotionBox className='slider_' drag='x' dragConstraints={constraintsRef}  >
                                        {
                                            atraccionesSantander.map((topic) => {
                                                return (
                                                    <motion.div className='div_homeTurism' key={topic.text}>
                                                        <Grid item xs={6} sm={6} md={3} lg={2} className='grid_cardHomeTurism'>
                                                            <div className='contain-carousel-packages'>
                                                                <img src={topic.img} alt={topic.text} />
                                                                <h4 style={{ color: "black" }}>{topic.text}</h4>
                                                            </div>
                                                        </Grid>
                                                    </motion.div>
                                                )
                                            })
                                        }

                                    </MotionBox>
                                </MotionConstraints>
                            </div>
                            <div className='contain-button-whatsapp'>
                                <a href='https://wa.link/uq1q0p' >
                                    <img src={Whatsapp} alt="" />
                                    <p>
                                        Habla con un asesor viaja al Eje Cafetero
                                    </p>
                                </a>
                            </div>
                        </div>
                    </main>
                </>
            }
            {
            }
            <ContactWellezy></ContactWellezy>


        </div>
    )
}

export default PackahesTourism